import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    DELETED_REASON,
    POST_IS_DELETED_FIND_WHY__IN_CODEX,
    POST_IS_DELETED_FIND_WHY__READ,
} from 'mk/autogenerated/translations/DeletedCommentAlert.aa04077cde96e4af20e9e3fa3adde88e'
import { aboutRulesCodexUrl } from 'mk2/apps/about/urls';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { Link } from 'mk2/components/Link';
import { DeletedByRole } from 'mk2/helpers/deleteable';
import { timeAt } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './DeletedCommentAlert.mscss';

interface OwnProps {
    heading: React.ReactNode;
    deletedByRole: DeletedByRole;
    deletedAt?: string;
    deletedBy?: string;
    reason?: string;
}

export const DeletedCommentAlert: React.FunctionComponent<OwnProps> = React.memo(({
    heading, deletedByRole, deletedAt, deletedBy, reason,
}) => (
    <div className={styles.DeletedCommentAlert}>
        <div className={styles.DeletedCommentAlert__head}>
            <div className={styles.DeletedCommentAlert__icon}>
                <FontAwesomeIcon icon={faTrash} />
            </div>
            <div className={styles.DeletedCommentAlert__heading}>
                {heading}
                {deletedBy && (
                    <span>
                        &nbsp;(
                        <Link
                            className={styles.DeletedCommentAlert__deletedBy}
                            to={url(blogsProfileUrl, { username: deletedBy })}
                        >
                            {deletedBy}
                        </Link>
                        )
                    </span>
                )}
            </div>
        </div>
        {deletedByRole === DeletedByRole.DeletedByAdmin && (
            <div className={styles.DeletedCommentAlert__codex}>
                <span>
                    <Link to={aboutRulesCodexUrl}>{POST_IS_DELETED_FIND_WHY__READ}</Link>
                    {POST_IS_DELETED_FIND_WHY__IN_CODEX}
                </span>
            </div>
        )}
        {reason && (
            <div className={styles.DeletedCommentAlert__reason}>
                <strong>{DELETED_REASON}</strong>: {reason}
            </div>
        )}
        {deletedAt && <div className={styles.DeletedCommentAlert__deletedAt}>{timeAt(deletedAt)}</div>}
    </div>
));

DeletedCommentAlert.displayName = 'DeletedCommentAlert';
